import React from "react";
import useBreakpoints from "../../hooks/useBreakpoints";
import { Checkbox, Collapse } from "../..";
import {
  ItemDetailsComponentProps,
  ItemMainComponentProps,
  MenuAction,
} from "../DataList.types";
import { useStyles } from "./DataItem.styles";
import MoreButton from "../../MoreButton";

interface DataItemProps<T> {
  item: T;
  idKey: keyof T;
  ItemMainComponent: (props: ItemMainComponentProps<T>) => JSX.Element;
  ItemDetailsComponent: (props: ItemDetailsComponentProps<T>) => JSX.Element;
  selected?: boolean;
  disabled?: boolean;
  onToggleSelect?: (item: T, checked: boolean) => void;
  moreActions?: MenuAction<T>[];
}

function DataItem<T>(props: DataItemProps<T>) {
  const {
    item,
    ItemMainComponent,
    ItemDetailsComponent,
    selected,
    onToggleSelect,
    moreActions,
    disabled,
  } = props;

  const { mdUp } = useBreakpoints();

  const classes = useStyles();

  const [expanded, setExpanded] = React.useState(false);

  const toggleExpand = () => {
    setExpanded((prev) => !prev);
  };

  return (
    <li className={classes.root}>
      <div className={classes.top}>
        <div className={classes.check}>
          <Checkbox
            color="primary"
            checked={selected}
            onChangeValue={(checked) => onToggleSelect?.(item, checked)}
            disabled={disabled}
          />
        </div>
        <div className={classes.main}>
          <ItemMainComponent
            item={item}
            expanded={expanded}
            onToggleExpand={toggleExpand}
          />
        </div>
        {mdUp && (
          <div className={classes.details}>
            <ItemDetailsComponent item={item} />
          </div>
        )}
        {moreActions && (
          <div className={classes.more}>
            <MoreButton<T> actions={moreActions} clickParam={item} />
          </div>
        )}
      </div>
      {!mdUp && (
        <Collapse in={expanded}>
          <div className={classes.bottom}>
            <ItemDetailsComponent item={item} />
          </div>
        </Collapse>
      )}
    </li>
  );
}

export default React.memo(DataItem) as unknown as typeof DataItem;
